import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import { linkSubscribe } from './../../conf/config';

import { clearErrors } from '../user/userActions';

import Aux from './../../hoc/_Aux';

import Image from './../../containers/UI/Image/Image';
import MessageModal from './../../containers/UI/MessageModal/MessageModal';

import Profile from './Profile/Profile';
import EditProfile from './Profile/Edit/EditProfile';

import CreateUserForm from './../forms/createUserForm';
import CGU from './../CGU/CGU';

import Zigzag from './../../containers/UI/Common/Shapes/Zigzag';
import DoubleHalfCircle from './../../containers/UI/Common/Shapes/DoubleHalfCircle';

// Assets
import MonstreImg from '../../assets/images/kiddy.svg';

export class Account extends Component {
    state = {
      displayingCGU: false
    };
    closeModalHandler = () => {
        const { dispatch } = this.props;
        dispatch( clearErrors() );
    }

    closePageHandler = () => {
        const { dispatch } = this.props;
        dispatch( push("/login") );
    }

    goToSalesHandler = () => {
        const {dispatch} = this.props;
        dispatch( clearErrors() );
        window.open(linkSubscribe, '_blank');

    }

    displayCGU = () => {
      this.setState({isDisplayingCGU:true});
    }

    closeCGU = () => {
      this.setState({isDisplayingCGU:false})
    }

    render(){

        const { isUserAuthenticated, user, isSubscriber } = this.props;

        let accountPage ='';
        
        if( isUserAuthenticated ){     
           
            if(this.props.match && this.props.match.path.match('/account/update')){
                accountPage =(<EditProfile />);
                
            }else if(!isSubscriber || this.props.match && this.props.match.path.match('/account/profile')){
                accountPage =(<Profile />);
            }
          
        }else{

            // new account creation
            accountPage =( 
                <div className="create-account-page">
                    <div className="close-page" onClick={this.closePageHandler}></div>
                    <div className="yellow-shape">    
                        <Zigzag color="#ffde39" />
                    </div>
                    <div className="blue-shape">    
                        <Zigzag color="#49d1e5" translateXaxis="10"/>
                    </div>
                    <div className="dual-half-circle">
                        <DoubleHalfCircle color1='#fff' color2='#fcea10' rotateAngle="0"/>
                    </div>
                    <h2>Mon super profil</h2>
                    <div className="account-character-profile">
                        <Image 
                            isResponsive='true'
                            imgPath={MonstreImg}
                            imgName="account-character"
                        />   
                    </div>
                    <CreateUserForm name="createUserForm" displayCGU={this.displayCGU} />
                </div>
            );
        }
        let messageModal = (
            <MessageModal 
                show={user.hasError}
                closeModalHandler={this.closeModalHandler}
                image="error"
                message= {user.errorMessage}
                zigzagColor="#49d1e5"
                zigzagClass="blue-shape"
            />);

        if(user.errorCode === 'auth/all-slots-used')
        {
            messageModal = (
                <MessageModal 
                    show={user.hasError}
                    class='all-slots-used'
                    closeModalHandler={this.closeModalHandler}
                    image="error"
                    message= {user.errorMessage}
                    zigzagColor="#49d1e5"
                    zigzagClass="blue-shape"
                    button="Je m’abonne"
                    buttonHandler={this.goToSalesHandler}
                />);
        }

        return(
            <Aux>
                {messageModal}
                {accountPage} 
                {(this.state.isDisplayingCGU)? <CGU closeHandler={this.closeCGU} /> : ''}
            </Aux>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        isUserAuthenticated: state.auth.isUserSignedIn,
        isSubscriber : state.auth.isSubscriber
    }
};

export default connect( mapStateToProps )(Account);


// WEBPACK FOOTER //
// ./src/components/Account/Account.js